export default __webpack_public_path__ + "static/media/Miu.c2d4fe9a.jpg";